import type { Doctor, Service, Variante } from '@booking/shared';

type Props = {
  doctor: Doctor;
  onPick: (service: Service, variante?: Variante) => void;
};

function formatPrice(amount: number, currency: 'CRC' | 'USD', minPrice: boolean | undefined): string {
  const desde = minPrice ? 'desde ' : '';
  if (currency === 'CRC') return `${desde}₡${amount.toLocaleString('es-CR')}`;
  return `${desde}$${amount.toLocaleString('en-US')}`;
}

/** Una tarjeta por cosa que se puede agendar. Cuando un servicio tiene varias
    opciones en el tarifario —Mirena y T de plata son la misma cita con precio
    distinto— se muestra una tarjeta por opción, con su precio. */
export function ServicePicker({ doctor, onPick }: Props) {
  return (
    <div className="service-picker">
      <h2>Elija un tipo de servicio</h2>
      {doctor.services.flatMap((s) => {
        const opciones = s.variantes ?? [];
        if (opciones.length < 2) {
          return [
            <button key={s.id} className="service-card" onClick={() => onPick(s)}>
              <div className="name">{s.name}</div>
              <div className="meta">
                {formatPrice(s.price, s.currency, s.minPrice)} ·{' '}
                {s.porZonas ? 'según las zonas que elijas' : `${s.durationMinutes} minutos`}
              </div>
              {s.porZonas?.nota && <div className="meta nota">{s.porZonas.nota}</div>}
            </button>,
          ];
        }
        return opciones.map((v) => (
          <button
            key={`${s.id}|${v.nombre}`}
            className="service-card"
            onClick={() => onPick(s, v)}
          >
            <div className="name">{v.nombre}</div>
            <div className="meta">
              {v.precio != null
                ? formatPrice(v.precio, v.moneda, false)
                : 'precio por confirmar'}{' '}
              · {v.minutos ?? s.durationMinutes} minutos
            </div>
            {v.nota && <div className="meta nota">{v.nota}</div>}
          </button>
        ));
      })}
    </div>
  );
}
